import React from 'react'
// import Header from '../../Components/Header/Header'
// import './Privacy.css'
// import '../TermsConditions/TermsCondition.css'
// import Footer from '../../Components/Footer/Footer'
function Privacy() {
  return (
    <div>
        {/* <Header/> */}
        <div className="terms-container">
        <h1>Privacy Policy</h1>
        <p className='terms-container-p'>
        Please refer to our Privacy Policy for information about data collection and use.

        <h4><b>Reservation of Rights</b></h4>
        <p>We reserve the right to request the removal of any links to our website. You agree to immediately remove all links upon request. We also reserve the right to amend these terms and conditions and our linking policy at any time. By continuing to link to our website, you agree to be bound to and follow these terms</p>
        <h3>Removal of Links from Our Website
        </h3>
        <p>If you find a link on our website that is offensive, you may contact us and request its removal. We will consider your request but are not obligated to remove the link or respond directly.
        </p>
        <h2><b>Disclaimer</b></h2>
        <p>To the maximum extent permitted by law, we exclude all representations, warranties, and conditions relating to our website and its use. This disclaimer does 1 not limit our or your liability for death, personal injury, fraud, or fraudulent misrepresentation. We are not liable for any loss or damage arising from the use   
        </p>
        <h4><b>Privacy Policy for Media Dunes
        </b></h4>
        <h2><b>Introduction
       </b> </h2>
        <p>At Media Dunes, accessible from [insert website address], one of our top priorities is protecting the privacy of our visitors. This Privacy Policy outlines the types of information we collect, how we use it, and your rights regarding that information.   
        </p>
        <h2><b>Questions and Further Information</b>
        </h2>
        If you have any questions or require further details about our Privacy Policy, please don't hesitate to contact us.



      <h2><b>  Scope of this Policy</b></h2>
      <p>
This Privacy Policy applies solely to our online activities and is valid for visitors to our website regarding the information they share and/or collect on Media Dunes. It does not extend to any information collected offline or through channels other than this website.   </p>
<h2> Consent</h2>
<p>By using our website, you consent to our Privacy Policy and agree to its terms.</p>
<h2> Information We Collect   </h2>
The personal information you provide, and the reasons for requesting it, will be made clear at the point of collection. This may include:   
<li>Name</li>
<li>Email address </li>
<li>	Phone number</li>
<li>	Message content and attachments (if you contact us directly)</li>
<li>	Contact information for account registration (name, company name, address) </li>
 
<h2><b> How We Use Your Information</b></h2>
We use the collected information for various purposes, including:
<li>	Website operation and maintenance</li>
<li>	Website improvement, personalization, and expansion</li>
<li>	User behavior analysis and understanding</li>
<li>	Development of new products, services, features, and functionality</li>
<li>	Communication (directly or through partners) for customer service, updates, marketing, and promotions
</li>
<li>	Email communication</li>
<li>	Fraud prevention</li>
<h2><b>Log Files</b></h2> 
<p>
Media Dunes follows the industry standard of using log files. These files record visitor activity on the website. The information collected includes IP addresses, browser types, internet service providers (ISPs), date/time stamps, referring/exit pages, and potentially the number of clicks. This data is not linked to any personally identifiable information. It's used for analyzing trends, administering the site, tracking user movement, and gathering demographic information.   </p>

<h2><b> Third-Party Privacy Policies</b></h2>
<p>You may consult the Privacy Policies of our advertising partners listed on our website. Third-party ad servers or networks use technologies like cookies, JavaScript, or web beacons to measure advertising campaign effectiveness and personalize advertising content across websites you visit. These technologies are controlled by the third parties, and Media Dunes has no access or control over them.</p>
 <h2><b>Third-Party Websites</b></h2>
<p>Our Privacy Policy does not apply to other advertisers or websites. We recommend reviewing the Privacy Policies of these third-party ad servers for more information on their practices and opting out of certain options.   
You can manage cookies through your individual browser settings. Refer to your browser's website for detailed instructions on cookie management.</p>
<b>CCPA Privacy Rights (Do Not Sell My Personal Information)</b>
<p>California consumers have the following CCPA rights:</p> 

 
  
     
    
      
      

<li><b>Right to Access:</b> Request copies of your personal data. A small fee may apply. </li>
<li><b>	Right to Rectification:</b> Request correction of inaccurate information or completion of incomplete data.</li>   
<li><b>	Right to Erasure:</b> Request deletion of your personal data under certain conditions.  </li>  
	 <li><b>Right to Restrict Processing:</b> Request restriction of your personal data processing under certain conditions. </li>   
	<li><b>Right to Object to Processing:</b> Object to the processing of your personal data under certain conditions.</li>
	<li><b>Right to Data Portability:</b> Request transfer of your data to another organization or directly to you under certain conditions.   </li>
 We have one month to respond to your requests. Please contact us to exercise any of these rights.   
GDPR Data Protection Rights 
We ensure you are fully aware of your data protection rights. Every user is entitled to:
<li><b>	Right to Access:</b> Request copies of Right to Erasure: Request deletion of your personal data under certain conditions. </li>
	  <li><b>Right to Restrict Processing:</b> Request restriction of your personal data processing under certain conditions.    </li>
<li><b>	Right to Object to Processing:</b> Object to the processing of your personal data under certain conditions.</li>
<li><b>Right to Data Portability:</b> Request transfer of your data to another organization or directly to you under certain conditions.  </li> 
We have one month to respond to your requests. Please contact us to exercise any of these rights.   
<h2><b>Children's Information </b></h2>
Protecting children's online safety is a priority. We encourage parents and guardians to monitor, participate in, and/or guide their children's online activity.
Media Dunes does not knowingly collect personal information from children under 13. If you believe your child has provided such information on our website, please contact us immediately. We will do our best to promptly remove such information from our records.   
Sources and related content

        </p>
</div>
    {/* <Footer/> */}
    </div>
  )
}

export default Privacy